<template>
  <section class="p-4 mt-4 bg-light border-top">
    <div class="container">
      <h1>All Projects</h1>
      <div class="row pt-3">
        <div
          class="col-lg-4 col-md-6 mb-4"
          v-for="project in getProjects"
          v-bind:key="project._id"
        >
          <ProjectCard :project="project" />
        </div>
        <PaginationNav />
      </div>
    </div>
  </section>
</template>

<script>
import ProjectCard from "@/components/ProjectCard.vue";
import PaginationNav from "@/components/PaginationNav.vue";

export default {
  name: "ProjectsView",
  components: {
    ProjectCard,
    PaginationNav,
  },
  mounted() {
    document.title = "Sephen de Vos - Projects";
  },
  data: function () {
    return {};
  },
  created() {
    this.$store.dispatch("resetPagination");
    this.$store.commit("setFilter", '{"_state": true}');
    this.$store.dispatch("fetchProjects");
  },
  computed: {
    getProjects() {
      return this.$store.getters.getProjects;
    },
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-img-top {
  border-radius: 3px;
}
</style>
